<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		@if (imgUrl != null) {
			<div class="media-panel">
				<button type="button" class="media-panel-preview" (click)="takePhoto()">
					<img [src]="imgUrl" alt="" />
				</button>
				<button type="button" class="media-panel-action" (click)="takePhoto()">
					<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
						photo_camera
					</span>
					{{ "IMAGE_CAPTURE__RETAKE" | transloco }}
				</button>
			</div>
		} @else {
			<button type="button" class="action-panel" (click)="takePhoto()">
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					photo_camera
				</span>
				<span class="action-panel-label">{{ "IMAGE_CAPTURE__ADD_BUTTON" | transloco }}</span>
			</button>
		}
	} @else {
		<ion-img *ngIf="imgUrl != null" [src]="imgUrl" (click)="takePhoto()"></ion-img>

		<div class="button-container" *ngIf="imgUrl == null">
			<ion-button shape="round" color="primary" (click)="takePhoto()">
				<ion-icon slot="end" name="camera-outline" />
				{{ "IMAGE_CAPTURE__ADD_BUTTON" | transloco }}
			</ion-button>
		</div>
	}
</app-question-template>
